import PageLayout from "../components/PageLayout";
import ReportingOptions from "../components/ReportingOptions";
import { useState } from "react";
import { type NewReportDto } from "../models/app/reporting";
import { summarizeObjectToString } from "../utils/summarizeObjectToString";
import HeaderOptions from "../components/ReusableComponents/HeaderOptions";
import { useCompanyDepartmentSelector } from "../components/ReusableComponents/CompanyDepartmentSelector";

const Reporting = () => {
    const employmentFilters = useCompanyDepartmentSelector();
    const { selectedCompany, selectedDepartment } = employmentFilters;

    const [isNewReportModalOpen, setIsNewReportModalOpen] = useState(false);

    const handleAddNewReport = () => {
        setIsNewReportModalOpen(!isNewReportModalOpen);
    };

    const handleFormSubmit = (data: NewReportDto) => {
        const summaryArray = new Array(0);
        summarizeObjectToString(data, summaryArray);

        alert(summaryArray.join(", "));
    };

    return (
        <PageLayout title="Reporting" header={false}>
            <div className="flex flex-col gap-6">
                <HeaderOptions
                    employmentFilters={employmentFilters}
                    // tailoredButtonTitle="New report"
                    // tailoredButtonOnClick={handleAddNewReport}
                />
                <ReportingOptions
                    selectedCompany={selectedCompany}
                    selectedDepartment={selectedDepartment}
                />
                {/* <DialogBox
                    isOpen={isNewReportModalOpen}
                    onClose={() => setIsNewReportModalOpen(false)}
                    title="Create new report"
                    size="xl"
                    closeButton
                >
                    <NewReportsForm onSubmit={handleFormSubmit} />
                </DialogBox> */}
            </div>
        </PageLayout>
    );
};

export default Reporting;
